(() => {
  const normalizedTypes = {"Pastile pentru întarzierea ejaculării":"Pastile pentru întârzierea ejaculării","Pastile pentru erectie cu efect minim 36 ore":"Pastile pentru erecție","Pastile extrastrong pentru erectie":"Pastile pentru erecție","Pastile 2 in 1 pentru erectie si intarzierea ejacularii":"Pastile 2 în 1 pentru erecție și întârzierea ejaculării","Pastile 2 in 1 extrastrong pentru erectie si intarzierea ejacularii":"Pastile 2 în 1 pentru erecție și întârzierea ejaculării","Pastile pentru erecție cu efect 6 ore minim":"Pastile pentru erecție","Viagra pentru femei":"Viagra pentru femei","10 pastile":"10 pastile","Capsule moi pentru erecție 36 de ore":"Capsule moi pentru erecție","Drajeuri masticabile pentru erecție 36 de ore":"Drajeuri masticabile pentru erecție","Jelly pentru erectie si ejaculare intarziata":"Jeleu pentru erecție și ejaculare întârziată","Viagra Jelly pentru femei":"Viagra Jelly pentru femei","Timbre sublinguale pentru erectie minim 36 de ore":"Timbre sublinguale pentru erecție","Pastile masticabile pentru erecție minim 6 ore":"Pastile masticabile pentru erecție","Jelly pentru erecție rapidă":"Jeleu pentru erecție","Pastile 2 în 1 pentru erecție și întârzierea ejaculării":"Pastile 2 în 1 pentru erecție și întârzierea ejaculării","Drajeuri masticabile pentru erecție":"Drajeuri masticabile pentru erecție","Pastile efervescente pentru erecție":"Pastile efervescente pentru erecție","Pastile pentru erecție":"Pastile pentru erecție","Pastile pentru erecție cu efect minim 36 ore":"Pastile pentru erecție","Pastile pentru erecție cu efect minim 6 ore":"Pastile pentru erecție","Pastile extra-strong pentru erecție prelungită":"Pastile pentru erecție","Jeleu pentru erecție rapidă":"Jeleu pentru erecție","Jeleu pentru pentru erecție rapidă cu efect minim 36 ore":"Jeleu pentru erecție","Pentru ejaculare bogată":"Pentru ejaculare bogată","Pastile extra pentru erecție":"Pastile pentru erecție","Jeleu pentru erectie rapida":"Jeleu pentru erecție"};
  const compose = (product) => {
    const rawType = String(product.type || product.product_type || '').trim();
    const type = Object.hasOwn(normalizedTypes, rawType) ? normalizedTypes[rawType] : rawType;
    const content = String(product.vendor || '').trim().toLowerCase()
      .replaceAll('2,5ml', '2,5 ml').replaceAll(' gr', ' g').replaceAll('capsula', 'capsule')
      .replaceAll('aplicari', 'aplicări').replaceAll('utilizari', 'utilizări').replaceAll('bucati', 'bucăți');
    if (!/^\d/.test(content)) return type;
    if (!type) return content;
    let lower = type.toLowerCase();
    const word = lower.split(' ')[0], quantity = content.split(' ')[0];
    if (word === quantity) return lower;
    if (['pastile', 'capsule', 'drajeuri', 'dropsuri', 'timbre', 'prezervative', 'tampoane'].includes(word)) {
      if (word === 'pastile' && content.includes('capsul')) lower = lower.replace('pastile', 'capsule');
      return quantity + ' ' + lower;
    }
    if (word === 'pentru') return content + ' ' + lower;
    if (word === 'viagra') lower = type;
    if (content.includes(' plic')) return content + ' cu ' + lower;
    const amount = content.split(' (')[0], tail = content.slice(amount.length);
    return amount + ' de ' + lower + tail;
  };
  window.szaComposeProductSummary = compose;
  const requests = new Map();
  const selector = '.product-wishlist[data-product-handle],.product-store-lists[data-product-handle]';
  const update = (card) => {
    const handle = card.getAttribute('data-product-handle');
    if (!handle || card.dataset.szaSummaryHandle === handle) return;
    card.dataset.szaSummaryHandle = handle;
    const root = window.Shopify?.routes?.root || '/';
    if (!requests.has(handle)) requests.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); }));
    requests.get(handle).then(product => {
      if (!card.isConnected || card.getAttribute('data-product-handle') !== handle) return;
      const title = card.querySelector('.product-wishlist__title,.product-store-lists__title');
      if (!title) return;
      const text = compose(product);
      let summary = card.querySelector('.sza-product-summary');
      if (text) {
        if (!summary) { summary = document.createElement('div'); summary.className = 'sza-product-summary sza-card-summary'; }
        summary.textContent = text;
        title.after(summary);
      } else if (summary) summary.remove();
      const media = card.querySelector('.product-wishlist__image,.product-store-lists__image');
      if (media) media.setAttribute('data-sza-image-available', String(product.available));
    }).catch(() => { card.dataset.szaSummaryState = 'unavailable'; });
  };
  const scan = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  };
  const start = () => {
    document.querySelectorAll('.product-page-info').forEach(info => {
      const placeSavings = () => {
        const price = info.querySelector(':scope > .product-page-info__price');
        const savings = info.querySelector(':scope > .product-page-info__price-sale-details');
        if (price && savings && price.nextElementSibling !== savings) price.after(savings);
      };
      placeSavings();
      new MutationObserver(placeSavings).observe(info, { childList: true });
    });
    scan(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') scan(record.target);
        else for (const node of record.addedNodes) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-handle'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

